import React from 'react';

interface AdminStatusBadgeProps {
  tone: 'draft' | 'live' | 'warning';
  children: React.ReactNode;
}

const toneClassName: Record<AdminStatusBadgeProps['tone'], string> = {
  draft: 'border-amber-300/20 bg-amber-400/10 text-amber-100',
  live: 'border-emerald-300/20 bg-emerald-500/10 text-emerald-100',
  warning: 'border-red-300/20 bg-red-500/10 text-red-100',
};

const AdminStatusBadge: React.FC<AdminStatusBadgeProps> = ({ tone, children }) => (
  <span
    className={`inline-flex rounded-full border px-3 py-1 text-[11px] font-semibold uppercase tracking-[0.22em] ${toneClassName[tone]}`}
  >
    {children}
  </span>
);

export default AdminStatusBadge;

